// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import values from "./data/opencode-go.json" with { type: "json" };
import { flattenModelCatalog, type ModelCatalog } from "../model-catalog.ts";

export const OPENCODE_GO_MODELS: ModelCatalog<typeof values, "opencode-go"> =
	flattenModelCatalog("opencode-go", values);
